import { Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

interface FavoriteUpgradeToastProps {
  maxFavorites: number;
}

export function FavoriteUpgradeToast({ maxFavorites }: FavoriteUpgradeToastProps) {
  return (
    <div className="flex items-start gap-3">
      <Star className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-medium text-gray-900">
          {maxFavorites === 1
            ? 'Free plan allows 1 saved location'
            : `You can save up to ${maxFavorites} locations`}
        </p>
        <Link
          to="/subscription"
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 font-medium mt-1"
        >
          Upgrade for more
          <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
}
